var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.34 20.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,12.14C0,11.81,.27,11.53,.61,11.53H19.69c.17-.01,.34,.05,.47,.18,.23,.23,.24,.6,.02,.84h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s-7.59,7.59-7.59,7.59c-.24,.24-.62,.24-.86,0s-.24-.62,0-.86l6.55-6.55H.61C.27,12.75,0,12.48,0,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.34,8.19c0,.34-.27,.61-.61,.61H.65c-.17,.01-.34-.05-.47-.18-.23-.23-.24-.6-.02-.84H.16s0,0,0,0H.16s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0S7.77,.18,7.77,.18c.24-.24,.62-.24,.86,0,.24,.24,.24,.62,0,.86L2.07,7.59H19.73c.34,0,.61,.27,.61,.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swapIcon.8c60aab60c10f780e0053c3d9b2b6a1b.svg";
export { ForwardRef as ReactComponent };